import UsersDataTable from "../../../components/dataTable/tables/UsersDataTable";

function UsersPageView() {
  return <UsersDataTable />;
}

export default UsersPageView;
